module.exports = __webpack_public_path__ + "img/banner04_info_pic4.1fa95bdb.jpg";